import { Role } from '@web/shared/module/auth';
import { Guid, Nillable } from '@web/utils';
import { UserStatus } from '../enums/user-status';
import { AccountType } from '../enums/account-type';

export class User {
  public constructor(
    private readonly data: {
      accountType: AccountType;
      activatedAt?: Nillable<Date>;
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      createdAt: Date;
      displayName?: Nillable<string>;
      email: string;
      firstName?: Nillable<string>;
      id: Guid;
      lastLoginAt?: Nillable<Date>;
      lastPasswordChangeAt?: Nillable<Date>;
      lastName?: Nillable<string>;
      roles: Role[];
      status: UserStatus;
      username: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get firstName(): Nillable<string> {
    return this.data.firstName;
  }

  public get lastName(): Nillable<string> {
    return this.data.lastName;
  }

  public get displayName(): Nillable<string> {
    return this.data.displayName;
  }

  public get username(): string {
    return this.data.username;
  }

  public get email(): string {
    return this.data.email;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get lastLoginAt(): Nillable<Date> {
    return this.data.lastLoginAt;
  }

  public get lastPasswordChangeAt(): Nillable<Date> {
    return this.data.lastPasswordChangeAt;
  }

  public get activatedAt(): Nillable<Date> {
    return this.data.activatedAt;
  }

  public get status(): UserStatus {
    return this.data.status;
  }

  public get roles(): Role[] {
    return this.data.roles;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }

  public get accountType(): AccountType {
    return this.data.accountType;
  }
}
